// extracted by mini-css-extract-plugin
export default {"CustomDocument":"_CustomDocument--V8pjW","CreateCustomDocumentText":"_CreateCustomDocumentText--YmGHj"};